import styled from "styled-components";


export const Container = styled.section`
  min-height: 100vh;
  padding-top: 12rem;
  padding-bottom: 6rem;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  align-items: center;
  gap: 6rem;
  background: rgba(0,0,0,0);

  .hero-text{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    max-width: 92rem;

    .eyebrow{
      font-family: 'Red Hat Mono', monospace;
      font-size: 1.6rem;
      opacity: 0.9;
    }

    h1{
      font-size: clamp(5.6rem, 4.4vw, 8.8rem);
      line-height: 1.06;
      font-weight: 700;
      letter-spacing: -0.02em;
      text-align: left;
      margin: 1.6rem 0 2.4rem;
    }

    .lede{
      font-size: clamp(1.9rem, 1.25vw, 2.3rem);
      line-height: 1.6;
      opacity: 0.85;
      max-width: 68rem;

      strong{
        color: var(--accent-text);
      }
    }
  }

  .hero-actions{
    display: flex;
    flex-wrap: wrap;
    gap: 1.6rem;
    margin-top: 4rem;

    .button{
      padding: 1.4rem 3.6rem;
      border: 1px solid var(--green);
    }

    .button.button-ghost{
      background-color: transparent;
      border-color: var(--accent-text);
      color: var(--accent-text);
      font-weight: 500;
      transition: background-color 0.25s, border-color 0.25s, color 0.25s;

      &:hover{
        filter: none;
        background-color: var(--green);
        border-color: var(--green);
        color: #fff;
      }
    }
  }

  .hero-actions .cv-link{
    align-self: center;
    font-family: 'Red Hat Mono', monospace;
    font-size: 1.4rem;
    color: var(--accent-text);
    padding: 0.4rem 0.2rem;

    &:hover{
      text-decoration: underline;
      text-underline-offset: 0.4rem;
    }
  }

  .hero-actions .button:focus-visible,
  .hero-actions .cv-link:focus-visible,
  .social-media a:focus-visible{
    outline: 2px solid var(--accent-text);
    outline-offset: 3px;
  }

  .social-media{
    display: inline-flex;
    align-items: center;
    gap: 3.2rem;
    padding-top: 4rem;

    img,span{
      font-size: 3rem;
      width: 3rem;
    }
  }

  .hero-image{
    img{
      display: block;
      width: 100%;
      max-width: 72rem;
      height: auto;
      margin-left: auto;
    }
  }


  @media(max-width: 960px){
    display: block;
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 15%;
    .hero-text{
      h1{
        font-size: 4rem;
        text-align: left;
      }
      .lede{
        font-size: 1.7rem;
      }
    }

    .hero-image{
      display: none;
    }
  }

  @media(max-width: 600px){
    margin-top: 25%;
  }
  @media(max-width: 480px){
    margin-top: 35%;
    .hero-text h1{
      font-size: 3.2rem;
    }
    .hero-actions .button,
    .hero-actions .cv-link{
      flex: 1 1 100%;
      text-align: center;
    }
  }
`
